import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AppSettings } from 'app/modules/shared/app.settings';
import { MiGrid2Component } from 'app/modules/shared/components/mi-grid-2/mi-grid-2.component';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';

@Component({
  selector: 'app-open-shift-pop',
  templateUrl: './open-shift-pop.component.html',
  styleUrls: ['./open-shift-pop.component.scss']
})
export class OpenShiftPopComponent implements OnInit {
  @Input() openshiftIDs: any;
  @Input() openshiftStatusId: any;
  @Input() labelActivated: any;
  urlAssign = '';
  gridTheme = 'mi';
  url = '';
  newUrl;
  gridColumn: any[] = [];
  exportUrl = '';
  printUrl = '';
  searchDisplay = true;
  columns: any = [];
  @ViewChild(MiGrid2Component) gridRef: MiGrid2Component;
  totalAndActiveCounts: { label: any; value: any; }[];
  buttons: any[] = [];
  userInfo: any;
  OpenShiftPop: any;
  OpenShiftEmitter: any;
  openShiftTeamDetails: any;
  hasShowOpenShiftPopUp = true;
  approveRejectId: any;
  ApproveId: string;
  rejectId: string;
  childView: any;
  params: any = '';
  statusId: any;
  isShiftApprovedOrRejected = false;
  constructor(
    private commonBindingDataService: CommonBindingDataService,
    private uiService: UiService,
    private commonService: CommonBindingDataService,
    private manageOpenShiftsService: ManageOpenShiftsService

  ) { }

  ngOnInit() {
    this.publishOpenShiftData(this.openshiftIDs);
    this.url = `/secure/open-shift-members/${this.openshiftIDs}/list/data`;
    this.openShiftGrid();
  }

  openShiftGrid() {
    this.columns.push({
      field: 'firstName', sortId: 'firstName', header: this.commonBindingDataService.getLabel('Applicant Name'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.colFullName(i))
    });
    this.columns.push({
      field: 'appliedOnStr', sortId: 'appliedOnStr', header: this.commonBindingDataService.getLabel('Applied On'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.getDate(i))
    });
    this.columns.push({
      field: 'applicationStatusStr', sortId: 'applicationStatusStr', header: this.commonBindingDataService.getLabel('label_status'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.setStatus(i))
    });
    this.buttons.push(this.commonBindingDataService.approveButton);

    this.buttons.push(this.commonBindingDataService.rejectButton);
  }
  setStatus(params) {
    let status = '';
    if (params.applicationStatus === 8010) {
      status = `<div title="` + params.applicationStatusStr + `" style="color:#32455F;font-weight: 600;text-transform:capitalize">` +
      params.applicationStatusStr + `</div>`;
    }
    if (params.applicationStatus === 8020) {
      status = `<div title="` + params.applicationStatusStr + `" style="color:#E09300;font-weight: 600;text-transform:capitalize">` +
      params.applicationStatusStr + `</div>`;
    }
    if (params.applicationStatus === 8030) {
      status = `<div title="` + params.applicationStatusStr + `" style="color:#00B055;font-weight: 600;text-transform:capitalize">` +
      params.applicationStatusStr + `</div>`;
    }
    if (params.applicationStatus === 8060) {
      status = `<div title="` + params.applicationStatusStr + `" style="color:#D91919;font-weight: 600;text-transform:capitalize">` +
      params.applicationStatusStr + `</div>`;
    }
    if (params.applicationStatus === 8070) {
      status = `<div title="` + params.applicationStatusStr + `" style="color:#32455F;font-weight: 600;text-transform:capitalize">` +
      params.applicationStatusStr + `</div>`;
    }
    if (params.applicationStatus === 8080) {
      status = `<div title="` + params.applicationStatusStr + `" style="color:#32455F;font-weight: 600;text-transform:capitalize">` +
      params.applicationStatusStr + `</div>`;
    }
    if (params.applicationStatus === 8090) {
      status = `<div title="` + params.applicationStatusStr + `" style="color:#0abde3;font-weight: 600;text-transform:capitalize">` +
      params.applicationStatusStr + `</div>`;
    }
    const eDiv = document.createElement('div');
    eDiv.innerHTML += status;
    return eDiv;
  }

  colFullName(params) {
    let lblActivate = '';
    let lastName = '';
    if (params.lastName !== null && params.lastName !== 'null') {
      lastName = params.lastName;
    }
    if (params.firstName) {
      if (params.numCountryCode !== undefined && params.numCountryCode !== null) {
        lblActivate = `<div title="` + params.firstName + ' ' + lastName + `">` + params.firstName + ' ' + lastName + '';
      } else {
        lblActivate = `<div title="` + params.firstName + ' ' + lastName + `">` + params.firstName + ' ' + lastName + '';
      }
    }
    const eDiv = document.createElement('div');
    eDiv.setAttribute('class', 'grid-comman-col');
    eDiv.innerHTML = lblActivate;
    return eDiv;
  }

  reloadGrid() {
    if (this.params == null) {
      this.params = '';
    }
    this.gridRef.updateUrl(this.url + this.params);
  }

  onActionBtnClicked(event: any) {
    const type = event.class;
    const data = event.row;
    switch (type) {
      case 'APPROVE':
        return this.onActionApproveClick(data);
      case 'REJECT':
        return this.onActionRejectClick(data);
      default:
        break;
    }
  }

  onActionRejectClick(data: any) {
    this.rejectId = '8060';
    this.approveRejectApi(data, this.rejectId);
  }

 onActionApproveClick(data: any) {
    this.ApproveId = '8030';
    this.approveRejectApi(data,  this.ApproveId);
  }

  totalCount(event: any) {
    this.totalAndActiveCounts = [
      {
        label: this.commonBindingDataService.getLabel('label_total_driver'),
        value: event ? event : 0
      }
    ];
  }

  getDate(params) {
    const tripTime = params.appliedOnStr;
    const date = this.commonBindingDataService.toTimezoneDateTimeStringFormatStr(params.appliedOnStr, params.timezoneAbbr);
    const time = this.commonBindingDataService.toTimezoneTimeFormatWithout(params.appliedOnStr, params.timezoneAbbr);

    let tripDateTime = '';
    if (tripTime !== null && tripTime !== 0) {
      tripDateTime = `<div title="` + date + `">` + date + `</div><div title="` + time + `">` + `</div>`;
    } else {
      tripDateTime = `<div title="">--</div>`;
    }
    const eDiv = document.createElement('div');
    eDiv.innerHTML += tripDateTime;
    return eDiv;

  }
  publishOpenShiftData(openShiftId) {
    this.manageOpenShiftsService.getOpenShiftPopDetails(openShiftId).subscribe(results => {
      this.openShiftTeamDetails = results;
      this.statusId = results.status;
    });
  }

  cancelUserForm() {
    this.manageOpenShiftsService.setDialogStatus(false);
    if (this.isShiftApprovedOrRejected) {
      this.manageOpenShiftsService.setValue(true);
    }
  }

  retractBroadcastBut() {
    this.manageOpenShiftsService.retractBroadcast(this.openshiftIDs).subscribe(results => {
    this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
    this.manageOpenShiftsService.setDialogStatus(false);
    this.manageOpenShiftsService.setValue(true);

    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }

  getBroadcastedCreatedBy(params: any) {
    if (params) {
      const delayCreatedByDate = this.commonService.toTimezoneDateFormat(params?.createdAt, params?.timezoneName);
      const delayCreatedByTime = this.commonService.toTimezoneTimeFormatWithout(params?.createdAt,
        params?.timezoneName) + (params?.timezoneAbbr ? ` (${params?.timezoneAbbr})` : '');
      return (delayCreatedByDate + ' ' + delayCreatedByTime);
    }
  }

  approveRejectApi(data, statusId) {
    const approveRejectData = {
      'openShiftId': data.openShiftId,
      'applicationStatus': statusId,
      'userId': data.userId
    };
    this.approveRejectId = data.id;
    this.manageOpenShiftsService.approveReject(this.approveRejectId, approveRejectData).subscribe(results => {
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
      this.reloadGrid();
      this.publishOpenShiftData(this.openshiftIDs);
      this.isShiftApprovedOrRejected = true;

    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
    });
  }
}

